<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group has-label">
          <label>Zeitraum</label>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="Bis"
            start-placeholder="Anfangsdatum"
            end-placeholder="Enddatum"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
            @change="fetchTableData"
            :picker-options="{ firstDayOfWeek: 1 }"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6" v-if="productCategories.length > 0">
        <div class="form-group has-label">
          <label>Warengruppen</label>
          <multiselect v-model="selectedProductCategories"
            :multiple="true"
            :options="productCategories"
            track-by="id"
            label="name"
            @input="fetchTableData"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <product-select
          v-model="product"
          @input="fetchTableData"
        />
      </div>
    </div>
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>Produkt</th>
          <th>Kategorie</th>
          <th>Lagerstand</th>
        </tr>
      </thead>
      <transition name="el-fade-in-linear">
        <tbody v-if="! loading">
          <tr v-for="product in products" :key="product.id">
            <td>
              <router-link :to="`/products/${product.id}`"
              >
                {{ product.name }}
                <span v-if="product.is_variation_of">({{ product.stringRepShort.join(' | ') }})</span>
              </router-link>
            </td>
            <td>
              <a href="#"
                v-for="(productCategory, index) in product.product_categories" :key="productCategory.id"
                @click.prevent="$emit('filterProductCategory', productCategory)"
              >
                {{ productCategory.name }}<span v-if="index !== product.product_categories.length - 1">, </span>
              </a>
            </td>
            <td class="text-right">{{ product.quantity }}</td>
          </tr>
        </tbody>
      </transition>
    </table>
  </div>
</template>

<script>
import { DatePicker } from 'element-ui'
import moment from 'moment'
import ProductSelect from 'src/components/product-select'

export default {
  components: {
    ProductSelect,
    [DatePicker.name]: DatePicker
  },
  data () {
    return {
      dateRange: [
        moment().subtract(6, 'months').startOf('month').format('YYYY-MM-DD'),
        moment().endOf('month').format('YYYY-MM-DD')
      ],
      products: [],
      productCategories: [],
      selectedProductCategories: [],
      product: null,
      loading: true
    }
  },
  methods: {
    fetchTableData () {
      this.loading = true

      const dateRangeFilter = this.dateRange ? encodeURIComponent(this.dateRange) : ''
      const productCategories = this.selectedProductCategories.length ? encodeURIComponent(this.selectedProductCategories.map(pc => pc.id)) : ''
      const product = this.product ? this.product.id : ''

      this.$http.get(`/products/unusued?date_range=${dateRangeFilter}&product_categories=${productCategories}&product=${product}`).then(({ data }) => {
        this.products = data
        this.loading = false
      })
    }
  },
  created () {
    this.fetchTableData()
    this.$http.get('/product_categories').then(({ data }) => { this.productCategories = data })
  }
}
</script>

<style>
</style>
